import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Stopwatch = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path d="M12.2071 15.2071L15.7071 11.7071L14.2929 10.2929L10.7929 13.7929L12.2071 15.2071Z" fill="currentColor" />
    <path
      clipRule="evenodd"
      d="M11 4H9.5V2H14.5V4H13V5.0582C17.2232 5.55313 20.5 9.14389 20.5 13.5C20.5 18.1944 16.6944 22 12 22C7.30558 22 3.5 18.1944 3.5 13.5C3.5 9.14389 6.77683 5.55313 11 5.0582V4ZM18.5 13.5C18.5 17.0899 15.5898 20 12 20C8.41015 20 5.5 17.0899 5.5 13.5C5.5 9.91015 8.41015 7 12 7C15.5898 7 18.5 9.91015 18.5 13.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path d="M6.20711 5.20711L3.70711 7.70711L2.29289 6.29289L4.79289 3.79289L6.20711 5.20711Z" fill="currentColor" />
    <path d="M21.7071 6.29289L19.2071 3.79289L17.7929 5.20711L20.2929 7.70711L21.7071 6.29289Z" fill="currentColor" />
  </Icon>
));

export default Stopwatch;
